import React from 'react';
import {
  Grid,
  Typography,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Icon from '../Icon/Icon';
import { Icons, ERROR } from '../../../utils/viewUtility';

const useStyles = makeStyles({
  refreshIcon:{
    cursor: "pointer"
  },
});

const ServerErrorPage = () => {
  
  const classes = useStyles();

  const handleRefresh = () => {
    window.location.reload(true);
  }

  return (
    <Grid container direction="column" justifyContent="center" alignItems="center">
      <Grid item> <Icon iconType={ Icons.IC_ERROR } /> </Grid>
      <Grid item>
        <Typography variant="h6">{ ERROR.SOMETHING_WRONG_MESSAGE }</Typography> 
      </Grid>
      <Grid item>
        <Typography variant="body1">{ ERROR.LOADING_SERVER_MESSAGE }</Typography>
      </Grid>
      <Grid item onClick = { handleRefresh } className={ classes.refreshIcon }><Icon iconType={ Icons.IC_REFRESH } /> </Grid>
    </Grid>
  );
};
export default ServerErrorPage;
